import { configureStore } from '@reduxjs/toolkit';
import companyReducer from './Company/companysSlice';
import diningTableReducer from './DiningTable/diningTableSlice';
import menuCategoryReducer from './MenuCategory/menuCategorySlice';
import menuReducer from './Menu/menuSlice';
import menuPreviewReducer from './MenuPreview/menuPreviewSlice';
import activeStoreReducer from './ActiveStore/activeStoreSlice';
import orderReducer from './Public/orderSlice';
import orderManageReducer from './ActiveStore/orderManageSlice';
import menuOptionReducer from './MenuOption/menuOptionSlice';
import reservationReducer from './Reservation/reservationSlice';
import reservationSettingsReducer from './ReservationSettings/reservationSettingsSlice';
import publicReservationReducer from './PublicReservation/publicReservationSlice';

const store = configureStore({
  reducer: {
    company: companyReducer,
    diningTable: diningTableReducer,
    menuCategory: menuCategoryReducer,
    menu: menuReducer,
    menuPreview: menuPreviewReducer,
    activeStore: activeStoreReducer,
    order: orderReducer,
    orderManage: orderManageReducer,
    menuOption: menuOptionReducer,
    reservation: reservationReducer,
    reservationSettings: reservationSettingsReducer,
    publicReservation: publicReservationReducer,
  },
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;

export default store;